export const faq = {
    title: '자주 묻는 질문',
    titleStaking: ' INO를 구매하기 위한 조건은 무엇인가요?',
    subTitleStaking:
        'INO 라운드로 NFT를 구매하려면 다음 단계를 수행해야 합니다:<br> <br>' +
        '<b>스텝 1</b>: 다음 주소에서 AIS 응용 프로그램을 다운로드하십시오:<br>' +
        "- Android: <a href=' https://ste.sbgroup.finance/apk/ste-app-release-v2.apk'> https://ste.sbgroup.finance/apk/ste-app-release-v2.apk</a><br>" +
        "- iOS: <a href='https://testflight.apple.com/join/xaFDhi6Y'>https://testflight.apple.com/join/xaFDhi6Y</a><br><br>" +
        '<b>스텝 2</b>: 사용자는 지침에 따라 KYC를 수행하고 확인을 받습니다.<br>' +
        'KYC 확인된 계정만 INO 라운드에 참여할 수 있습니다.',
    titleStakingHold: '<b>2. NFT를 구매하면 무엇을 얻을 수 있나요??</b>',
    subTitleStakingHold:
        '이 INO 라운드에서 Primitive NFT를 $250/NFT에 구매하면 플레이어는 하루에 단 3분의 운동으로 $15를 벌 수 있습니다. ' +
        '단 20일 만에 회수 기간을 거쳐 30일 만에 최대 $450를 벌 수 있습니다.<br><br>' +
        '또한 매우 매력적인 NFT 민트 메커니즘을 통해 1쌍의 NFT(남성 + 여성)에서 7개의 어린이 NFT를 생성할 수 있습니다.' +
        '플레이어는 매일 5분의 규칙적인 운동으로 최소 $2700/30일을 쉽게 또는 그 이상 즉시 벌 수 있습니다.<br>' +
        '얻은 이익은 투자한 초기 자본의 몇 배입니다.<br><br>',
    titleStakingInformation: '<b>3. Token AIS는 무엇인가요?</b>',
    subTitleStakingInformation:
        'AIS은 Stretch-to-Earn의 대표적인 토큰으로, SB와 연결되어 이 응용 프로그램에 대한 유틸리티를 생성합니다.<br>' +
        'AIS 토큰에 대한 기본 정보를 알아봅시다:<br>' +
        '- 기호: AIS<br>' +
        '- 총 공급량: 10,000,000',
    titleInterestAfter: '<b>4. 필요할 때 누구에게 도움을 요청할 수 있나요??</b>',
    subTitleInterestAfter: '궁금한 사항은 다음 연락처로 문의하십시오: <a>info@dragonsb.finance</a>',
    titleNotReceivingInterest: '<b>5. AIS에 대해 자세히 알아볼 수 있는 곳은 어디인가요?</b>',
    subTitleNotReceivingInterest:
        'AIS에 대한 자세한 내용은 블로그를 방문하십시오.<br>' +
        '- $AIS에 대하여: <a href="https://blog.dragonsb.finance/ste-the-heart-of-stretch-to-earn/">https://blog.dragonsb.finance/ste-the-heart-of-stretch-to-earn/</a><br>' +
        '- AIS의 메커니즘과 경제에 대하여: <a href="https://blog.dragonsb.finance/a-super-rare-chance-to-hunt-nft-from-hot-trend-stretch-to-earn/"> https://blog.dragonsb.finance/a-super-rare-chance-to-hunt-nft-from-hot-trend-stretch-to-earn/</a><br>',
};
